import Vue from 'vue';
import App from './App';
import Router from 'vue-router';
import plugins from './libraries/plugins'
import { ssgRouters,routerInterceptor } from './router'

import ElementUI from 'element-ui';
import common from "./components/common/index.js"
import {  } from "./components/directive";
import { getCookie } from "./components/cookie";
import modules from './components/index'
import editors from "./components/common/editor/tinymce.js"


Vue.config.productionTip = false;
Vue.prototype.$cookieStore = { getCookie }

import "./assets/css/reset.css"
import "./assets/css/button.css"
import 'element-ui/lib/theme-chalk/index.css'
import "./assets/css/modify.css"
import "./assets/css/checkbox.css"
import "./filter.js"
// import "./assets/iconfont/iconfont.css"
import "./assets/icons/index.js"
Vue.use(ElementUI);
Vue.use(plugins);
Vue.use(Router);
Vue.use(common);
Vue.use(modules)
Vue.use(editors);

const router =  new Router({
  routes: ssgRouters(modules)
})

// router.beforeEach((to, from, next) => {
// 	routerInterceptor(to, from ,next);
// })

/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	render: h => h(App),
	data: {
		eventHub: new Vue()
	}
})



